<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de Cuidado no Desenvolvimento Infantil">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/atencao-basica/relatorio-cuidado-desenvolvimento-infantil/List'

export default {
    components: {List},
}
</script>